export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_MISSING_MFA = "USER_LOGIN_MISSING_MFA";
export const USER_LOGIN_ERROR = "USER_LOGIN_ERROR";
export const TRY_LOGIN = "TRY_LOGIN";
export const USER_LOGOUT = "USER_LOGOUT";
export const USER_LOGIN = "USER_LOGIN";
